const SELECTOR_LESSON_ACTIONS = ".js-lesson-actions";
const AUTOPLAY_LIKE_BUTTON = ".vjs-autoplay__like-button";

interface LikeToggledDetail {
  status: "saved" | "unsaved" | string;
  likeableType: string;
  likeableId: string | number;
}

function updateLessonActions(detail: LikeToggledDetail) {
  if (detail.likeableType !== "lesson") return;

  const lessonId = String(detail.likeableId);
  const isLiked = detail.status === "saved";

  // Keep the main lesson like button in sync when present
  const actions = document.querySelector(SELECTOR_LESSON_ACTIONS);
  if (actions) {
    const form = actions.querySelector<HTMLFormElement>("form");
    const button = form?.querySelector<HTMLButtonElement>("button");
    const labelSpan = button?.querySelector("span");

    if (button) {
      button.dataset.status = String(isLiked);
    }

    if (labelSpan) {
      labelSpan.textContent = isLiked ? "Saved" : "Save lesson";
    }

    if (form) {
      // Ensure the endpoint still matches the current lesson id
      form.action = `/lesson/${lessonId}/likes/toggle`;
    }
  }

  // Keep the player element dataset in sync for autoplay overlay etc.
  const playerEl = document.querySelector<HTMLElement>(".js-video");
  if (playerEl && playerEl.dataset.lessonId === lessonId) {
    playerEl.dataset.likedStatus = String(isLiked);
  }

  // Update any autoplay like button that might be visible
  const autoplayButton =
    document.querySelector<HTMLButtonElement>(AUTOPLAY_LIKE_BUTTON);
  if (autoplayButton) {
    autoplayButton.dataset.status = String(isLiked);
  }
}

export function setupLikesSync() {
  window.addEventListener("save:toggled", ((
    event: CustomEvent<LikeToggledDetail>
  ) => {
    if (!event.detail) return;
    updateLessonActions(event.detail);
  }) as EventListener);
}
